// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.client-logos-section[data-v-5f1ba7da] {
  height: calc(100% - 25px) !important;
}
.client-logos-section .subheading[data-v-5f1ba7da] {
  position: relative;
}
.client-logos-section .edit-btn[data-v-5f1ba7da] {
  position: absolute;
  right: 0px;
  top: -4px;
}
.client-logos-section .pre-block[data-v-5f1ba7da] {
  height: 390px;
}
.cet-note-content[data-v-5f1ba7da] {
  width: 100%;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.cet-note-content h1[data-v-5f1ba7da],
.cet-note-content h2[data-v-5f1ba7da],
.cet-note-content h3[data-v-5f1ba7da] {
  margin-bottom: 0.5em;
}
.cet-note-content p[data-v-5f1ba7da] {
  margin-bottom: 0.5em;
}
.team-member-img[data-v-5f1ba7da] {
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.team-member-img img[data-v-5f1ba7da] {
  max-height: 50px;
  max-width: 50px;
  border: 3px solid #d2d2d2;
  border-radius: 50%;
}
.team-member-img.b-red img[data-v-5f1ba7da] {
  border-color: #cf1e60;
}
.team-member-img.b-pink img[data-v-5f1ba7da] {
  border-color: #ff8a65;
}
.cet-logo-container[data-v-5f1ba7da] {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.cet-logo[data-v-5f1ba7da] {
  max-width: 40%;
  max-height: 10rem;
  height: auto;
  display: block;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
